import React from "react";
import { withToastManager } from "react-toast-notifications";
import {
  Container,
  Grid,
  Segment,
  Header,
  Image,
  Divider,
  Modal,
  Button,
  Label,
} from "semantic-ui-react";
import { getPackages, makePayment } from "./service";
import MakePayment from "./make-payment";
import GetPackages from "./get-package";
import spectranet from "../spectranet.png";

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      requestData: null,
      packages: null,
      isPaying: false,
      show: false,
      isFetching: false,
      modalOpen: false,
      copyText: "copy",
    };
    this.alertId = null;
  }

  loadedViaIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  componentDidMount() {
    const message = JSON.stringify({ action: "loaded" });
    window.parent.postMessage(message, "*");
  }

  getPackages = (data) => {
    this.hideAlert();
    this.setState({ isFetching: true, packages: null }, () => {
      getPackages(data)
      
        .then((response) => {
          
          if (response.responseCode === "0") {
           
          
            this.setState(
              {
                requestData: {
                  ...data,
                  accountId:
                    response.customer && response.customer.custReference,
                },
                packages: response,
                isFetching: false,
                show: true
              },
              
            );
          } else {
            this.handleError(response.responseDescription, "isFetching");
          }
        })
        .catch((err) => this.handleError(err, "isFetching"));
    });
  };

  makePayment = (data) => {
    this.hideAlert();
    this.setState({ isPaying: true }, () => {
      makePayment(data)
        .then((response) => {
          if (response.refId) {
            const message = JSON.stringify({
              action: "success",
              value: response.refId,
            });
            window.parent.postMessage(message, "*");
            this.setState({
             transactionLogId: response.refId,
              isPaying: false,
            });

            if (!this.loadedViaIframe()) {
              this.setState({ modalOpen: true });
            }
          } else {
            this.handleError(response.responseDescription, "isPaying");
          }
        })
        .catch((err) => this.handleError(err, "isPaying"));
    });
  };

  handleError = (err, mode) => {
    this.setState({ [mode]: false }, () => {
      this.showAlert(err, "warning");
    });
  };

  showAlert = (err, type) => {
    const { toastManager } = this.props;
    toastManager.add(
      err,
      {
        appearance: type,
        autoDismiss: true,
        placement: "top-center",
        autoDismissTimeout: 10000,
      },
      (id) => {
        this.alertId = id;
      }
    );
  };

  hideAlert = () => {
    const { toastManager } = this.props;
    this.alertId && toastManager.remove(this.alertId);
    this.alertId = null;
  };

  goBackToGetPackages = () => {
    this.setState({ packages: null, show: false });
  };

  closePortlet = () => {
    const message = JSON.stringify({ action: "close" });
    window.parent.postMessage(message, "*");
  };

 

  handleModalClose = () => {
    this.setState({ modalOpen: false, copyText: "copy" });
  };

  copyToClipboard = () => {
    const { transactionLogId } = this.state;
    const elem = document.createElement("textarea");
    elem.value = transactionLogId;
    elem.setAttribute("readonly", "");
    elem.style.position = "absolute";
    elem.style.left = "-9999px";
    document.body.appendChild(elem);

    const selectedEs =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;

    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);

    if (selectedEs) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selectedEs);
      
    }
    this.setState({ copyText: "copied!" }, () => {
      setTimeout(() => {
        this.setState({ copyText: "copy" });
      }, 1000);
    });
  };

  render() {
    const {
      requestData,
      packages,
      isFetching,
      isPaying,
      modalOpen,
      transactionLogId,
      copyText,
      show,
    } = this.state;

    return (
      <Container className="main-container">
        <Grid>
          <Grid.Row>
            <Grid.Column computer={16} tablet={16} mobile={16}>
              <Segment.Group raised>
                <Segment clearing className="logo-header">
                  <Header floated="right">
                    <Image src={spectranet} size="large" />
                  </Header>
                </Segment>

                <Segment.Group raised>
                  <Segment padded="very">
                    <div className="packages">
                    { !show &&  (
                      <GetPackages
                        getPackages={this.getPackages}
                        back={this.closePortlet}
                        isFetching={isFetching}
                      />
                    )}
                   
                    </div>
                    <div className = "make-payment">
                      {show && packages && (
                        <MakePayment
                          requestData={requestData}
                          packages={packages}
                          isPaying={isPaying}
                          makePayment={this.makePayment}
                          back={this.goBackToGetPackages}
                        />
                      )}
                    </div>
                  </Segment>
                </Segment.Group>
                <Divider hidden />
                <Divider hidden />
              </Segment.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Modal size="tiny" open={modalOpen} onClose={this.handleModalClose}>
          <Header
            icon="money bill alternate outline"
            content="Payment Reference"
          />
          <Modal.Content>
            <Segment raised textAlign="left" color="yellow" size="large">
              <Label as="a" attached="top right" onClick={this.copyToClipboard}>
                {copyText}
              </Label>
              <span>{transactionLogId}</span>
            </Segment>
          </Modal.Content>
          <Modal.Actions>
            <Button color="yellow" onClick={this.handleModalClose} inverted>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

export default withToastManager(App);

